import React, { useState } from 'react'
import "./settings.css"
import { useDispatch, useSelector } from 'react-redux';
import { Key, Link, Info, Plus } from "lucide-react"
import Input from '../ReUsedComponents/inputField/Input'

import { Toaster, toast } from 'sonner'
import { generateApiKey, udapteCallbackUrl, statusCallbackUrl, 
  getPhoneNumbers, updatePhoneNumberCallback, getUserRoles, 
    inviteNewUser, getAllUsers, resendInvitationEmail } from '../../apis/Settings' 
   
import { loginUser } from '../../apis/Authentication';
import { setUserInfo, setUserToken, setLoginState, setSandBoxNumber, 
  setApiKey, setCallbackUrl, setStatusCallbackUrl } from '../../redux-store/AuthSlice';

import { Table, Pagination, Spin, Tooltip }from "antd";

const Settings = () => {

    const dispatch = useDispatch()
    const action = useSelector((state) => state.action)

    const selector = useSelector((state) => state.auth)
    const userDetails = JSON.parse(selector?.userInfo)

    function isJSON(str) {
      try {
        JSON.parse(str);
        return true;
      } catch (e) {
        return false;
      }
    }
    
    const userApiKey = JSON.parse(selector?.apiKey);
    const userCallbackUrl = isJSON(selector?.callbackUrl)? JSON.parse(selector?.callbackUrl):selector?.callbackUrl 
    const userStatusCallbackUrl = isJSON(selector?.statusCallbackUrl)? JSON.parse(selector?.statusCallbackUrl):selector?.statusCallbackUrl 

    const [isHidden, setIsHidden] = useState(true);
    const [password, setPassword] = useState('');
    const [formErrors, setFormErrors] = useState()

    const [passwordModal, setPasswordModal] = useState(false)
    const [callbackUrlModal, setCallbackUrlModal] = useState(false)
    const [statusCallbackUrlModal, setStatusCallbackUrlModal] = useState(false)
    const [phonenumberCallbackUrlModal, setPhonenumberCallbackUrlModal] = useState(false)
    const [inviteUserModal, setInviteUserModal] = useState(false)

    const [webhookUrl, setWebhookUrl] = useState('');
    const [statusWebhookUrl, setStatusWebhookUrl] = useState('');
    const [resendInviteId, setResendInviteId] = useState(null)

    const [step1, setStep1] = useState(true)
    const [step2, setStep2] = useState(false)
    const [step3, setStep3] = useState(false)
    const [step4, setStep4] = useState(false)
     
    const [phoneNumbers, setPhoneNumbers] = useState([])
    const [users, setUsers] = useState([])
    const [userRoles, setUserRoles] = useState([])
    const [callbackDetails, setCallbackDetails] = useState({ phoneNumberId: '',callbackUrl: '', statusCallbackUrl: ''})

    const [userInviteDetails, setUserInviteDetails] = useState({ firstName: '',lastName: '', username: '', role: ''})

    useState(() =>{
       getPhoneNumbers(dispatch).then(resp => {
        setPhoneNumbers(resp.data)
       })

       getUserRoles(dispatch).then(resp => {
        setUserRoles(resp.data.data)
       })

       getAllUsers(dispatch).then(resp => {
        setUsers(resp.data)
       })
       
    }, [])


    console.log(users)
    


    const columns = [
      {
          title: 'Name',
          dataIndex: 'verifiedName',
          key: 'verifiedName',
          width: 200,
          sorter: (a, b) => a.verifiedName.length - b.verifiedName.length,
      },
      {
          title: 'Number',
          dataIndex: 'number',
          key: 'number',
          width: 150,
          sorter: (a, b) => a.number.length - b.number.length,
      },
      {
          title: 'Callback',
          dataIndex: 'callbackUrl',
          key: 'callbackUrl',
          width: 300,
          sorter: (a, b) => a.callbackUrl.length - b.callbackUrl.length,
      },
      {
          title: 'Status callback',
          key: 'statusCallbackUrl',
          width: 300,
          render: (_, record) => <span>{record.statusCallbackUrl ? record.statusCallbackUrl : '__'}</span>,
          sorter: (a, b) => (a.statusCallbackUrl?.length || 0) - (b.statusCallbackUrl?.length || 0),
      },
      {
          title: 'Actions',
          key: 'actions',
          width: 100,
          render: (_, record) => (
              <div className="contacts-table-actions">
                  <span
                      className="material-symbols-outlined"
                      style={{cursor: 'pointer'}}
                      onClick={() => {
                          setCallbackDetails({
                              phoneNumberId: record.id,
                              callbackUrl: record.callbackUrl,
                              statusCallbackUrl: record.statusCallbackUrl,
                          });
                          setPhonenumberCallbackUrlModal(true);
                      }}
                  >
                      edit
                  </span>
              </div>
          ),
      },
  ];
  


  const userColumns = [
    {
        title: 'Name',
        dataIndex: 'firstName',
        key: 'verifiedName',
        width: 200,
        render: (_, record) => <div>
             <p className='font-bold text-[15px]'>{record.firstName ? record.firstName : '__'} {record.lastName ? record.lastName : '__'}</p>
             <p className='text-slate-400'>{record.username ? record.username : '__'}</p>
          </div>,
        },
        {
          title: 'Role',
          key: 'role',
          width: 100,
          render: (_, record) => <span className='text-gray-500 font-bold text-[12px]'>{record.role ? record.role : '__'}</span>,
          sorter: (a, b) => (a.role?.length || 0) - (b.role?.length || 0),
       },
    {
        title: 'Status',
        key: 'status',
        width: 200,
        render: (_, record) => <div className='text-white text-[12px]'>{record.status === "PENDING_EMAIL_CONFIRMATION" ? <span className='bg-yellow-400 py-0.5 px-2 rounded-lg'>Pending Email Confirmation</span> : <span className='bg-green-500 py-0.5 px-2 rounded-lg'>Active</span>}</div>,
        sorter: (a, b) => (a.status?.length || 0) - (b.status?.length || 0),
    },
    {
        // title: 'Actions',
        key: 'actions',
        width: 100,
        render: (_, record) => (
          <div>
            {record.status === "ACTIVE"?
               <div className="contacts-table-actions flex items-center text-blue-500 hover:cursor-pointer">
                   Edit
               </div>
               :
                <>
                {resendInviteId === record.invitationGuid? <p>Resending ...</p> :
                 <div className="contacts-table-actions flex items-center text-blue-500 hover:cursor-pointer"
                    onClick={() => handleResendInviteEmail(record?.invitationGuid)}
                    >
                   Resend Invite
                </div>
                }
                </>
              
            
            }
          


        </div>
        ),
    },
];

  const handleOnChange = (e) => {
    setCallbackDetails({ ...callbackDetails, [e.target.name]: e.target.value })
}

    const validate = () => {
        let errors = {}
        if (!password) {
          errors['password'] = 'Password is required!'
        }
        setFormErrors(errors)
        return errors
      };

      const validateUrl = () => {
        let errors = {}
        if (!webhookUrl) {
          errors['webhookUrl'] = 'Url is required!'
        }
        if (webhookUrl && webhookUrl.trim() !== '') {
          try {
            new URL(webhookUrl)
          } catch {
            errors['webhookUrl'] = 'Invalid callback URL format!'
          }
        }
    
        setFormErrors(errors)
        return errors
      };

      const validateStatusUrl = () => {
        let errors = {}

        if (statusWebhookUrl && statusWebhookUrl.trim() !== '') {
          try {
            new URL(statusWebhookUrl)
          } catch {
            errors['webhookUrl'] = 'Invalid status callback URL format!'
          }
        }
      
        setFormErrors(errors)
        return errors
      };

      const validateNumberCallbackUrl = () => {
        let errors = {}
        if (!callbackDetails.callbackUrl) {
          errors['callbackUrl'] = 'Field is required!'
        }
        if (callbackDetails.callbackUrl && callbackDetails.callbackUrl.trim() !== '') {
          try {
            new URL(callbackDetails.callbackUrl)
          } catch {
            errors['callbackUrl'] = 'Invalid callback URL format!'
          }
        }
        setFormErrors(errors)
        return errors
      };


      const validateUserInviteDetails = () => {
        let errors = {}
        if (!userInviteDetails.firstName) {
          errors['firstName'] = 'Field is required!'
        }
        if (!userInviteDetails.lastName) {
          errors['lastName'] = 'Field is required!'
        }
        if (!userInviteDetails.username) {
          errors['email'] = 'Field is required!'
        }
        if (!userInviteDetails.role) {
          errors['role'] = 'Field is required!'
        }
        setFormErrors(errors)
        return errors
      };


    const copyKeyToClipboard = () => {
        navigator.clipboard.writeText(userDetails?.client?.apiKey)
          .then(() => {
            toast.success('API Key copied!')
          })
          .catch(err => {
            toast.error('Invalid username or password!')
          });
      };

    const copyCallbackToClipboard = () => {
      navigator.clipboard.writeText(userCallbackUrl)
        .then(() => {
          toast.success('Url copied!')
        })
        .catch(err => {
          toast.error('Invalid username or password!')
        });
    };

    const copyStatusCallbackToClipboard = () => {
      navigator.clipboard.writeText(userStatusCallbackUrl)
        .then(() => {
          toast.success('Url copied!')
        })
        .catch(err => {
          toast.error('Invalid username or password!')
        });
    };
 
    const loading = () =>{
        return <div class="lds-dual-ring"></div>
    }

    const handleGenerateKey = () => {
        if (Object.keys(validate()).length === 0) {
          loginUser(dispatch, {username: userDetails?.username, password: password}).then((resp) => {
            if (resp?.status === 200) {
                localStorage.setItem("token", resp?.data?.data?.token)
                localStorage.setItem("userinfo", JSON.stringify(resp?.data?.data?.user))
                localStorage.setItem("loginState", true)
                localStorage.setItem("sandBoxNumber", resp?.data?.data?.config?.sandboxNumber)
                dispatch(setUserToken(localStorage.getItem("token")))
                dispatch(setUserInfo(localStorage.getItem("userinfo")))
                dispatch(setLoginState(localStorage.getItem("loginState")))
                dispatch(setSandBoxNumber(localStorage.getItem("sandBoxNumber")))
               
                generateApiKey(dispatch).then(resp => {
                  console.log(resp)
                  if (resp?.status === 200) {
                    if (resp?.data.error === true) {
                      toast.error(resp?.data.message, { theme: "colored" })
                    } else {
                      localStorage.setItem("apikey", JSON.stringify(resp?.data?.data?.apiKey))
                      localStorage.setItem("callbackUrl", JSON.stringify(resp?.data?.data?.callbackUrl))
                      dispatch(setApiKey(localStorage.getItem("apikey")))
                      dispatch(setCallbackUrl(localStorage.getItem("callbackUrl")))
                      handleCloseModal(dispatch)
                      toast.success("Generated successful!", { theme: "colored" })
                      // window.location.reload()
                    }
                  }
                  else { toast.error("Error occurred!", { theme: "colored" }) }
                })
            }
            else if (resp?.response?.data?.message?.includes("User does not exists") || resp?.response?.status === 401) {
                toast.error('Invalid password!')
                console.log(resp)
            }

            else {
                toast.error('Something went wrong.Try again!')
                console.log(resp)
            }

        })
        
            
        }
    
      }

    const handleUpdateWebhook = () => {
        if (Object.keys(validateUrl()).length === 0) {
          udapteCallbackUrl(dispatch, {url: webhookUrl}).then(resp => {
                  console.log(resp)
                  if (resp?.status === 200) {
                    if (resp?.data.error === true) {
                      toast.error(resp?.data.message, { theme: "colored" })
                    } else {
                      localStorage.setItem("callbackUrl", webhookUrl)
                      dispatch(setCallbackUrl(localStorage.getItem("callbackUrl")))
                      handleCloseModal(dispatch)
                      toast.success("Generated successful!", { theme: "colored" })
                      // window.location.reload()
                    }
                  }
                  else { toast.error("Error occurred!", { theme: "colored" }) }
                })
            }
      }

    const configureStatusCallback = () => {
      if (Object.keys(validateStatusUrl()).length === 0) {
          statusCallbackUrl(dispatch, {url: statusWebhookUrl}).then(resp => {
                  if (resp?.status === 200) {
                      localStorage.setItem("statusCallbackUrl", statusWebhookUrl)
                      dispatch(setStatusCallbackUrl(localStorage.getItem("statusCallbackUrl")))
                      handleCloseModal(dispatch)
                      toast.success("Status Callback URL updated successfull!", { theme: "colored" })
                  }
                  else { toast.error("Error occurred!", { theme: "colored" }) }
                })
      }
          
      }

    const handleUpdatePhoneNumberCallback = () => {
        if (Object.keys(validateNumberCallbackUrl()).length === 0) {
          updatePhoneNumberCallback(dispatch, callbackDetails).then(resp => {
                  console.log(resp)
                  if (resp?.status === 200) {
                    if (resp?.data.error === true) {
                      toast.error(resp?.data.message, { theme: "colored" })
                    } else {
                      handleCloseModal(dispatch)
                      toast.success("Updated successful!", { theme: "colored" })
                      window.location.reload()
                    }
                  }
                  else { toast.error("Error occurred!", { theme: "colored" }) }
                })
            }
      }



    const handleInviteUser = () => {
        if (Object.keys(validateUserInviteDetails()).length === 0) {
          inviteNewUser(dispatch, userInviteDetails).then(resp => {
                  console.log(resp)
                  if (resp?.status === 201) {
                    if (resp?.data.error === true) {
                      toast.error(resp?.data.message, { theme: "colored" })
                    } else {
                      handleCloseModal(dispatch)
                      toast.success("Invite sent successful!", { theme: "colored" })
                      window.location.reload()
                    }
                  }
                  else { 
                    console.log(resp?.response?.data)
                    toast.error(resp?.response?.data?.message, { theme: "colored" }) 
                  }
                })
            }
      }


      const handleResendInviteEmail = (userUUID) => {
          setResendInviteId(userUUID)
          resendInvitationEmail(userUUID).then(resp => {
                  if (resp?.status === 200) {
                    if (resp?.data.error === true) {
                      toast.error(resp?.data.message, { theme: "colored" })
                      setResendInviteId(null)
                    } else {
                      handleCloseModal(dispatch)
                      toast.success("Invitation resent successfully!", { theme: "colored" })
                      setResendInviteId(null)
                    }
                  }
                  else { 
                    console.log(resp?.response?.data)
                    toast.error(resp?.response?.data?.message, { theme: "colored" }) 
                    setResendInviteId(null)
                  }
                })
         }

    const handleCloseModal = () => {
        setPassword('')
        setPasswordModal(false)
        setCallbackUrlModal(false)
        setStatusCallbackUrlModal(false)
        setPhonenumberCallbackUrlModal(false)
        setInviteUserModal(false)
        setFormErrors([])
        setWebhookUrl('');
        setStatusWebhookUrl('');
        document.getElementById("form-modal").reset();
      }
  
    return (
        <div class='settings-page'>

            <p className='settings-page-title'>Account Settings</p>
            <p className='text-slate-400 text-[14px]'>Manage your account configuration and preferences</p>
              
            <div className='mt-3 bg-gray-200 flex flex-wrap rounded rounded-[10px]'>
              <p className={`settings-step-${step1}`} onClick={() => {setStep1(true); setStep2(false); setStep3(false); setStep4(false)}}>Configurations</p>
              <p className={`settings-step-${step2}`} onClick={() => {setStep1(false); setStep2(true); setStep3(false); setStep4(false)}}>Balance Alert</p>
              <p className={`settings-step-${step3}`} onClick={() => {setStep1(false); setStep2(false); setStep3(true); setStep4(false)}}>Phone Numbers</p>
              <p className={`settings-step-${step4}`} onClick={() => {setStep1(false); setStep2(false); setStep3(false); setStep4(true)}}>Users</p>
            </div>


            {step1? 
             <div className='apikey-callback-section'>

             <div className='border py-6 px-2 rounded rounded-[10px]'>
              <div className="flex items-center">
                <Key className='mr-2 text-blue-600 h-7 w-7 bg-blue-100 p-1 rounded rounded-[10px]'/><p className='font-bold text-[16px]'>API Key</p>
              </div>
                <div className='flex flex-wrap border rounded rounded-[10px] mt-4'>
                {isHidden ? (
                   <input id="apikey-input-visible-value" value={'#'.repeat(userDetails?.client?.apiKey.length || 0)} readOnly />
                  ) : (
                    <input id="apikey-input-visible-value" value={userApiKey || ''} readOnly />
                  )}

                  {  isHidden ? (
                    <Tooltip title="Show" placement="bottom">
                      <span id="visibility-eye" onClick={() => setIsHidden(false)} className="material-symbols-outlined" style={{ cursor: 'pointer', marginLeft: 8 }}  >
                              visibility</span>
                      </Tooltip>
                    ): (
                    <Tooltip title="Hide" placement="bottom">
                    <span id="visibility-eye" onClick={() => setIsHidden(true)} className="material-symbols-outlined" style={{ cursor: 'pointer', marginLeft: 8 }}
                      >visibility_off </span>
                      </Tooltip>
                      ) 
                    }
                   <Tooltip title="Copy Key" placement="bottom">
                   <span >
                     <span id='copy-btn' class="material-symbols-outlined" onClick={copyKeyToClipboard}>content_copy</span>
                    </span>
                  </Tooltip>
                </div>
                <button className='mt-4 bg-blue-400 text-[12px] text-white hover:bg-blue-300 p-2 rounded rounded-[10px]' onClick={()=> setPasswordModal(true)}>Generate New API Key</button>     
             </div>

         {/* /////////////////////callback url */}
        <div className='border py-6 px-2 rounded rounded-[10px] mt-4'>
          <Tooltip
            title={
              <>
                We POST to this URL whenever a customer sends a message to your WhatsApp Business number (text, media, interactive).
                Reply 200 OK. <a href='https://docs.lipachat.com/api/webhooks#inbound-message-webhooks' target='_blank' rel="noreferrer">[Learn more]</a>
              </>
            }
            placement="top"
          >
            <div className='flex items-center w-max'>
              <Link className='mr-2 text-blue-600 h-7 w-7 bg-blue-100 p-1 rounded rounded-[10px]'/>
              <p className='font-bold text-[16px]'>Webhook URL </p><Info className='h-4' />
            </div>
          </Tooltip>

          <div className='flex flex-wrap border bg-gray-100 rounded rounded-[10px] mt-4'>
            <input
              id='apikey-input-visible-value'
               className='bg-gray-100'
              readOnly
              value={userCallbackUrl}
              placeholder="https://api.yourapp.com/webhooks/whatsapp/callback"
            />
            <div id='credentials-btns'>
            <Tooltip title="Copy Url" placement="bottom">
              <span id='copy-btn' className="material-symbols-outlined" onClick={copyCallbackToClipboard}>content_copy</span>
            </Tooltip>

             <Tooltip title="Update Url" placement="bottom">
              <span id='copy-btn' className="material-symbols-outlined" onClick={() => setCallbackUrlModal(true)}>Edit</span>
              </Tooltip>
            </div>
          </div>
        </div>

        {/* /////////////////////configure status callback url */}
        <div className='border py-6 px-2 rounded rounded-[10px] mt-4'>
          <Tooltip
            title={
              <>
                We POST status updates (delivered, read, failed) for messages you send. Not used for customer messages.
                <a href='https://docs.lipachat.com/api/webhooks#message-status-callbacks' target='_blank' rel="noreferrer"> [Learn more]</a>
              </>
            }
            placement="top"
          >
            <div className='flex items-center w-max'>
              <Link className='mr-2 text-blue-600 h-7 w-7 bg-blue-100 p-1 rounded rounded-[10px]'/>
              <p className='font-bold text-[16px]'>Status Callback URL </p><Info className='h-4' />
            </div>
          </Tooltip>

          <div className='flex flex-wrap border bg-gray-100 rounded rounded-[10px] mt-4'>
            <input
              id='apikey-input-visible-value'
              className='bg-gray-100'
              readOnly
              placeholder="Ex: https://api.yourapp.com/webhooks/whatsapp/status"
              value={userStatusCallbackUrl}
            />
            <div id='credentials-btns'>
              <Tooltip title="Copy Url" placement="bottom">
                <span id='copy-btn' className="material-symbols-outlined" onClick={copyStatusCallbackToClipboard}>content_copy</span>
              </Tooltip>
              <Tooltip title="Update Url" placement="bottom">
                <span id='copy-btn' className="material-symbols-outlined" onClick={() => setStatusCallbackUrlModal(true)}>Edit</span>
              </Tooltip>
            </div>
          </div>
        </div>

          </div> 
     
            :

            step2?
            <div className='mt-5 border border-solid p-4 rounded-[10px]'>
                  <p className='font-bold text-[18px]'>Balance Alert</p>
                  <p className='text-slate-400 text-[13px]'>We shall send you email notification whenever your account credits go lower than the level you specify below.</p>  
                  <input className='min-w-[100%] border py-1 px-2 rounded-[7px] focus:border-blue-500 focus:outline-none my-3' value='50' /> <br/>
                   <button className='bg-red-500 py-2 px-3 rounded-[10px] text-white text-[14px] hover:bg-red-400'>Update Amount</button>
            </div> 
            
            
            : 
            step3?
          <div className='min-h-[50vh] mt-5 border border rounded rounded-[10px] p-2'> 
          <p className='font-bold mb-2'>Phone Numbers</p>
          <Spin spinning={action.pending}>
          <div className='border rounded rounded-[10px]'>
              <Table dataSource={phoneNumbers?.data} columns={columns}
                pagination={false}
                scroll={{ x: 300, y: '100vh' }}
                sticky
                className="custom-table"
              /> 
              <div style={{ padding: '10px 5px', textAlign: 'center' }}>
              <Pagination
                className="custom-pagination"
                align='end'
                total={phoneNumbers?.totalElements}
                showSizeChanger
              />
              </div>
            </div>
            </Spin>   
          </div> 
              :
              <div className='min-h-[50vh] mt-5 border border rounded rounded-[10px] p-2'> 
              <div className='flex justify-between align-center items-center text-center mb-3'>
              <p className='font-bold ml-2'>Users</p>
              <button type='button' className='bg-blue-500 flex items-center text-white rounded-lg text-sm py-2 px-2 hover:bg-blue-400' onClick={()=> setInviteUserModal(true)}><Plus className='h-4' />Invite User</button>
              </div>
              <Spin spinning={action.pending}>
              <div className='border rounded rounded-[10px]'>
                  <Table dataSource={users?.data} columns={userColumns}
                    pagination={false}
                    scroll={{ x: 300, y: '100vh' }}
                    sticky
                    className="custom-table"
                  /> 
                </div>
                </Spin>   
              </div>
            }
    

      {/* /////////////////////enter password modal  */}
      <div className={passwordModal ? 'create-modal-active' : 'create-modal-inactive'} >
      <div className="form-div-section">
        <form id="form-modal" className='view-modal-content'>
          <p className='modal-title'> Enter Password
          <span id='close-button' class="material-symbols-outlined" onClick={() => handleCloseModal(dispatch)}>close</span>
            </p>
            <p style={{fontSize: '13px', color: '#494F55'}}>NB: Generating a new API Key will result to old key not working</p>
          <div className="dialog-inputs">
          <div className="password-form-group">
                <input type='password' name='password' className="password-form-control" onChange={(e)=> setPassword(e.target.value)} />
                <span id="password-error">{formErrors?.password}</span>
            </div>
          </div>
          <div className='dialog-footer'>
            
            <div>
            {!action.pending?
                <button type='button' className="submit-btn" onClick={handleGenerateKey}>Generate</button>:
                <button className="submit-btn-disabled" disabled={true}>{loading()}</button>
            }
            </div>

          </div>
        </form>
      </div>
      </div>

       {/* /////////////////////update callback url modal  */}
       <div className={callbackUrlModal ? 'create-modal-active' : 'create-modal-inactive'} >
       <div className="form-div-section">
        <form id="form-modal" className='view-modal-content'>
          <p className='modal-title'> Enter Url
          <span id='close-button' class="material-symbols-outlined" onClick={() => handleCloseModal()}>close</span>
            </p>
          <div className="dialog-inputs">
          <div className="password-form-group">
                <input type='text' name='webhookUrl' className="password-form-control" value={webhookUrl} onChange={(e)=> setWebhookUrl(e.target.value)} />
                <span id="password-error">{formErrors?.webhookUrl}</span>
            </div>
          </div>
          <div className='dialog-footer'>
            
            <div>
            {!action.pending?
                <button type='button' className="submit-btn" onClick={handleUpdateWebhook}>Update</button>:
                <button className="submit-btn-disabled" disabled={true}>{loading()}</button>
            }
            </div>

          </div>
        </form>
        </div>
      </div>

       {/* /////////////////////configure status callback url modal  */}
       <div className={statusCallbackUrlModal ? 'create-modal-active' : 'create-modal-inactive'} >
       <div className="form-div-section">
        <form id="form-modal" className='view-modal-content'>
          <p className='modal-title'> Enter Url
          <span id='close-button' class="material-symbols-outlined" onClick={() => handleCloseModal()}>close</span>
            </p>
          <div className="dialog-inputs">
          <div className="password-form-group">
                <input type='text' name='statusWebhookUrl' className="password-form-control" value={statusWebhookUrl} onChange={(e)=> setStatusWebhookUrl(e.target.value)} />
                <span id="password-error">{formErrors?.webhookUrl}</span>
            </div>
          </div>
          <div className='dialog-footer'>
            
            <div>
            {!action.pending?
                <button type='button' className="submit-btn" onClick={configureStatusCallback}>Update</button>:
                <button className="submit-btn-disabled" disabled={true}>{loading()}</button>
            }
            </div>

          </div>
        </form>
       </div>
      </div>


         {/* /////////////////////update phonenumber callback url modal  */}
         <div className={phonenumberCallbackUrlModal ? 'create-modal-active' : 'create-modal-inactive'} >
         <div className="form-div-section">
          <form id="form-modal" className='view-modal-content'>
              <p className='modal-title'> Update Callback URL
                 <span id='close-button' class="material-symbols-outlined" onClick={() => handleCloseModal()}>close</span>
              </p>

              <div className="dialog-inputs">
                <Input label="Callback URL *" name='callbackUrl' type='text' value={callbackDetails?.callbackUrl} handleChange={(e) => handleOnChange(e)} errorMessage={formErrors?.callbackUrl}/>
                <Input label="Status Callback Url *" name='statusCallbackUrl' type='text' value={callbackDetails?.statusCallbackUrl} handleChange={(e) => handleOnChange(e)}/>
              </div>
            
              <div className='dialog-footer'>
                {!action.pending?
                    <button type='button' className="submit-btn" onClick={handleUpdatePhoneNumberCallback}>Update</button>:
                    <button className="submit-btn-disabled" disabled={true}>{loading()}</button>
                }
              </div>
            </form>
          </div>
        </div>


          {/* /////////////////////invite new user modal  */}
          <div className={inviteUserModal ? 'create-modal-active' : 'create-modal-inactive'} >
         <div className="form-div-section">
          <form id="form-modal" className='view-modal-content'>
              <p className='modal-title'> Invite User
                 <span id='close-button' class="material-symbols-outlined" onClick={() => handleCloseModal()}>close</span>
              </p>

              <div className="grid grid-cols-2 gap-2 ">
                <Input label="First Name *" name='firstName' type='text' handleChange={(e) => setUserInviteDetails({...userInviteDetails, firstName: e.target.value})}/>
                <Input label="Last Name *" name='lastName' type='text' handleChange={(e) => setUserInviteDetails({...userInviteDetails, lastName: e.target.value})}/>
                <Input label="Email *" name='username' type='email' handleChange={(e) => setUserInviteDetails({...userInviteDetails, username: e.target.value})} errorMessage={formErrors?.email}/>
                <div className='flex flex-col'>
                    <label className='filter-label-api'>Role*</label>
                    <select type='text' name="role" className='bg-gray-100 flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-base ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm h-[36px] border-[0.5px] border-gray-300 !focus:border-blue-500 !focus:outline-none focus:ring-0 !focus:ring-offset-0 !focus-visible:ring-0 !focus-visible:ring-offset-0' 
                    value={userInviteDetails?.role}  onChange={(e) => setUserInviteDetails({...userInviteDetails, role: e.target.value})}>
                    <option id='option' value="" selected>Select User Role</option>
                    {userRoles.map((item, id) =>
                        <option id='option' key={id} style={{ fontSize: '14px' }} value={item}>{item}</option>
                    )}
                    </select>
                    <span className='text-[11px] text-red-500'>{formErrors?.role}</span>
                </div>
              </div>
            
              <div className='dialog-footer'>
                {!action.pending?
                    <button type='button' className="submit-btn" onClick={handleInviteUser}>Submit</button>:
                    <button className="submit-btn-disabled" disabled={true}>{loading()}</button>
                }
              </div>
            </form>
          </div>
        </div>


        <Toaster position="top-right" expand={false} richColors/>
        </div>
    )
}

export default Settings